import { Injectable } from '@angular/core';
import { Domain } from '@monsido/ng2/modules/models/api/domain';
import { DomainGroupsEntity } from '@monsido/ng2/modules/models/api/interfaces/domain.interface';
import { safeClone } from '@client/app/shared/utils/object-utils';

export enum DomainPickerValueType {
    'Domain' = 'Domain',
    'DomainGroup' = 'DomainGroup',
}

export interface DomainValue extends Domain {
    type: DomainPickerValueType.Domain
}
export interface DomainGroupValue extends DomainGroupsEntity {
    type: DomainPickerValueType.DomainGroup;
    domainId: number;
}

@Injectable({
    providedIn: 'root',
})
export class DomainsService {

    flattenDomains (domains: Domain[], includeDomainGroups = true): (DomainValue | DomainGroupValue)[] {
        const result: (DomainValue | DomainGroupValue)[] = [];
        for (const domain of domains) {
            const domainValue: DomainValue = safeClone(domain) as DomainValue;
            domainValue.type = DomainPickerValueType.Domain;
            result.push(domainValue);

            if (domainValue.domain_groups && includeDomainGroups) {
                for (const group of domainValue.domain_groups) {
                    const domainGroupValue = safeClone(group) as DomainGroupValue;
                    domainGroupValue.type = DomainPickerValueType.DomainGroup;
                    domainGroupValue.domainId = domain.id;
                    result.push(domainGroupValue);
                }
            }
        }

        return result;
    }
}
